import { Icon } from '@pwc/pwc-deals-ui';
import styles from './CloseButtonPill.module.scss';
import { LinkType } from '../types/LinkType';

type Props = {
  link: LinkType;
  index: number;
  onDelete: (link: LinkType) => void;
};

export const CloseButtonPill = ({ link, index, onDelete }: Props) => (
  <button
    type="button"
    className={styles.button}
    onClick={(e) => {
      e.preventDefault();
      onDelete(link);
    }}
    data-testid={`clearable-display-pill-x-${index}`}
  >
    <Icon
      name="close"
      className="fill"
      width="10"
      data-testid={`clearable-link-icon ${index}`}
    />
  </button>
);
